import { Component, Input } from '@angular/core';
import { NeskoAbEigentumListEntry } from 'app/core/amtlichebewertung-api';
import { ListLoader } from 'app/shared/components/list-loader/list-loader';
import { ListLoaderObservable } from 'app/shared/components/list-loader/list-loader-observable';
import { of } from 'rxjs';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { NeskoAbEigentumListEntryVm, NeskoabViewmodelService } from 'app/neskoab/neskoab-viewmodel.service';
import { LinkComponent, NavTarget } from '../../../shared/components/link/link.component';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { KompaktPersonenadresseComponent } from '../../../shared/kompaktdarstellung/personenadresse/kompakt-personenadresse.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-neskoab-nutzniesser',
  templateUrl: './neskoab-nutzniesser.component.html',
  styleUrls: ['./neskoab-nutzniesser.component.scss'],
  imports: [
    RubrikComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    NgClass,
    KompaktPersonenadresseComponent,
    LinkComponent,
    TranslatePipe
  ]
})
export class NeskoabNutzniesserComponent {
  _nutzniesser: Array<NeskoAbEigentumListEntry>;

  listLoader: ListLoader<NeskoAbEigentumListEntryVm>;

  navTargets = NavTarget;

  @Input()
  hasRight = false;

  constructor(private neskoabViewmodelService: NeskoabViewmodelService) {
    keysToTranslate<string>(['neskoab.Nutzniessung', 'neskoab.Nutzniesser']);
  }

  @Input()
  set nutzniesser(value: Array<NeskoAbEigentumListEntry>) {
    if (!value || value.length === 0) {
      this.listLoader = new ListLoaderObservable<NeskoAbEigentumListEntryVm>(undefined, 1, of([]));
      return;
    }
    this.listLoader = new ListLoaderObservable<NeskoAbEigentumListEntryVm>(
      undefined,
      1,
      of(this.neskoabViewmodelService.getViewModel(value))
    );
    this._nutzniesser = value;
  }
}
